module.exports = __webpack_public_path__ + "static/media/chatLoader.6a6b37a6.gif";